import * as React from 'react';


import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Top from "../Top";
import Bottom from "../Bottom";


const Private = () => {

  const navigate = useNavigate();




  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };



  return (
    <Box sx={{ minWidth: 320 }}>
      <Top title="개인정보처리방침" />

      <Box className={'contentStart'}
           sx={{
             p: '0 15px 80px 15px',
             mt: 10,
             '& > p': {
               margin: '6px',
               fontSize: 12,
             },
             'ol': {paddingLeft: '20px'},
             'ol li': {mb: '10px', fontSize: 12},
             'ul': {paddingLeft: '20px', mt: '5px'},
             'ul li': {fontSize: 12, mb: 0},
             'h2': {textAlign: 'center', fontSize: 18},
             'h3': {fontSize: 14},
             'table': {
               mt: '10px',
               borderCollapse: 'collapse',
               overflow: 'scroll',
               minWidth: 270,
               whiteSpace: 'nowrap',
               display: 'block'
             },
             'th': {
               border: '1px solid #ccc',
               background: '#f1f1f1',
               textAlign: 'center',
               padding: '5px',
               fontSize: 12,
             },
             'td': {border: '1px solid #ccc', padding: '5px', fontSize: 12, whiteSpace: 'normal'},
             '.bold': {fontSize: 12, fontWeight: 700}


           }}>

        <h2>듀얼헬스케어 개인정보처리방침</h2>
        <p>&nbsp;</p>


        <p className='bold'>㈜듀얼헬스케어(이하 “회사”)는 사용자(이하 또는 “회원”)의 개인정보 보호를 중요시하며, ‘개인정보보호법’, ‘정보통신망 이용촉진 및 정보 보호에 관한 법률’에
          따라 개인정보 보호규정 및 정보통신부가 제정한 ‘개인정보 보호지침’을 준수하여 적법한 절차를 통해 개인 정보를 수집하고 활용합니다.
        </p>
        <p>&nbsp;</p>

        <h3>제1조 (개인정보의 이용목적과 수집항목 및 수집방법)</h3>

        <p>회사는 서비스 이용에 반드시 필요한 개인정보를 다음과 같은 목적을 위해 처리합니다. 수집되는 개인정보는 다음의 목적 이외의 용도로 처리되지 않으며, 처리 목적과 항목이 변경되는 경우에는 별도의
          동의를 받는 등 필요한 조치를 이행 후 진행됩니다.
          회사는 듀얼헬스케어의 서비스(이하 ‘서비스) 이용에 필요한 최소한의 개인 정보만을 수집합니다.
        </p>
        <table>
          <colgroup>
            <col width='14%'/>
            <col width='50%'/>
            <col width='18%'/>
            <col width='18%'/>
          </colgroup>
          <tbody>
          <tr>
            <th>구분</th>
            <th>수집 항목</th>
            <th>이용 목적</th>
            <th>수집 기간</th>
          </tr>
          <tr>
            <td>회원 가입 및 회원 정보 관리, 서비스 제공/서비스 관련 공지사항 전달/서비스 민원 사항 처리</td>
            <td>[필수]이름, 성별, 생년월일, 휴대전화번호, 이메일 주소 및 비밀번호, 또는 카카오, 네이버, Apple 등 가입을 위해 필요한 제휴 서비스 계정, 위치 정보</td>
            <td>듀얼헬스케어 서비스 이용 및 회원 관리</td>
            <td>회원 탈퇴 또는 계약 종료 후 1년 동안 보관됨</td>
          </tr>
          <tr>
            <td>본인 인증</td>
            <td>이름, 성별, 생년월일, 내국인 정보, 이동정보통신사 및 휴대전화번호, 본인 인증 시 수집되는 CI/DI 값 등 회원 본인 확인을 위해 필요한 식별자 정보</td>
            <td>듀얼헬스케어 서비스 회원 가입</td>
            <td>회원 탈퇴 시</td>
          </tr>
          <tr>
            <td>건강검진 예약 서비스</td>
            <td>[필수] 이름, 성별, 생년월일, 휴대전화번호, 주소, 예약정보(건강검진 예약일, 검진패키지명, 금액 등) 기업 회원일 경우 [필수] 이름, 소속 기업, 이메일 주소, 휴대전화번호,
              생년월일, 성별 [선택] 사번, 소속팀
            </td>
            <td>듀얼헬스케어 서비스 이용(예약, 관리, 상담 문의)</td>
            <td>회원 탈퇴 또는 계약 종료 후 2년 동안 보관됨</td>
          </tr>
          <tr>
            <td>검진 센터 방문 내역 조회 서비스/검진 결과 조회 서비스/검사 정보 제공 서비스/맞춤형 건강검진 추천 서비스</td>
            <td>[필수] 이름, 성별, 생년월일, 휴대전화번호, 이메일 주소, 검진기관 방문 내역(검진종류/검진연도/검진일자/검진기관명/검사항목/검사수치/소견)</td>
            <td>듀얼헬스케어 서비스 이용(예약, 관리, 상담 문의)</td>
            <td>회원 탈퇴 또는 계약 종료 후 1년 동안 보관됨</td>
          </tr>
          <tr>
            <td>비의료 건강관리 서비스</td>
            <td>[필수] 이름, 성별, 생년월일, 휴대전화번호, 주소, 소속 기관(기업회원일 경우), 사용자 제공 정보, 건강검진 방문
              내역(검진종류/검진연도/검진일자/검진기관명/검사항목/검사수치/소견), 상담 내역, 사용자가 앱 내 기록한 정보, 사용자가 서비스내에 연동한 기기를 통해 수집되는 개인의 신체, 행동,
              생리적인
              정보, 걸음수 정보
            </td>
            <td>듀얼헬스케어 서비스 이용(상담 문의, 관리)</td>
            <td>회원 탈퇴 또는 계약 종료 후 2년 동안 보관됨</td>
          </tr>
          <tr>
            <td>심리상담 예약 서비스</td>
            <td>[필수] 이름, 성별, 생년월일, 휴대전화번호, 주소, 소속 기관(기업회원일 경우)</td>
            <td>듀얼헬스케어 서비스 이용(예약, 관리, 상담 문의)</td>
            <td>회원 탈퇴 또는 계약 종료 후 2년 동안 보관됨</td>
          </tr>
          <tr>
            <td>고객 상담/문의</td>
            <td>[필수] 이름, 성별, 생년월일, 휴대전화번호, 주소, 소속 기관(기업회원일 경우), 사용자가 입력한 문의 내용</td>
            <td>듀얼헬스케어 서비스 이용(고객센터 문의, 상담)</td>
            <td>회원 탈퇴 또는 계약 종료 후 2년 동안 보관됨</td>
          </tr>
          </tbody>
        </table>
        <ol>
          <li>개인신용정보 수집방법
            <ul>
              <li>듀얼헬스케어 서비스 앱 또는 웹 내에서 사용자가 직접 입력한 정보</li>
              <li>듀얼헬스케어 서비스 앱 내에서 동의하에 병의〮원 또는 의료정보 조회서비스를 통해 수집되는 정보</li>
              <li>상담과 민원처리 과정에서 생성된 정보</li>
              <li>서비스 이용 과정에서 자동으로 수집되는 정보</li>
              <li>기업/기관에서 제공하는 정보</li>
            </ul>
          </li>
          <li>자동 생성/수집 정보
            <ul>
              <li>듀얼헬스케어 서비스 이용 과정에서 방문일시, 서비스 이용 기록, 위치 정보, 접속 IP 주소, 쿠키 항목을 자동 수집합니다.</li>
            </ul>
          </li>
          <li>자동 생성/수집 정보 거부 방법
            <ul>
              <li>위치 정보는 단말기의 설정을 변경하여 위치 정보 수집을 차단할 수 있습니다.</li>
              <li>회사는 사용자에게 맞춤형 서비스를 제공하고 신속한 서비스 환경 구축을 위해 쿠키를 사용합니다. 쿠키는 웹사이트가 이용자의 브라우저로 전송되어 기록되는 작은 정보 파일입니다.
              </li>
              <li>쿠키 정보는 사용자의 컴퓨터와 모바일 기기는 식별할 수는 있지만 사용자 개개인을 식별하지는 않습니다. 쿠키 저장 허용과 차단(거부)는 아래와 같이 진행하실 수 있습니다. 단, 쿠기
                저장을
                거부할 경우 일부 서비스를 이용할 수 없습니다.
              </li>
              &nbsp;
              <li>웹 브라우저에서 쿠키 허용/차단</li>
              <ul>
                <li>크롬(Chrome) : 웹 브라우저 설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용 기록 삭제</li>
                <li>엣지(Edge) : 웹 브라우저 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제</li>
              </ul>
              &nbsp;
              <li>모바일 브라우저에서 쿠키 허용/차단</li>
              <ul>
                <li>크롬(Chrome) : 웹 브라우저 설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용 기록 삭제</li>
                <li>사파리(Safari) : 모바일 기기 설정 &gt; 사파리(Safari) &gt; 고급 &gt; 모든 쿠키 차단</li>
                <li>삼성 인터넷 : 모바일 브라우저 설정 &gt; 인터넷 사용 기록 &gt; 인터넷 사용 기록 삭제</li>
              </ul>
            </ul>
          </li>
        </ol>
        <p>&nbsp;</p>

        <h3>제2조 (개인정보 수집 및 이용에 대한 동의)</h3>
        <p>“서비스”는 개인 정보 수집 및 이용”에 대한 별도의 동의 획득 절차를 두고 사용자가 이에 대해 “동의한다” 또는 “동의하지 않는다” 버튼을 통해 선택할 수 있는 절차가 있습니다.
          “동의한다” 버튼을 선택하면 개인 정보 수집 및 이용에 동의한 것으로 봅니다.</p>
        <p>사용자는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 받는 별도의 불이익은 없습니다. </p>
        <p>단, “동의하지 않는다”를 선택할 경우 서비스 이용이 불가능하거나 일부 서비스 이용에 제한이 따르게 됩니다.</p>
        <p>&nbsp;</p>

        <h3>제3조 (개인정보 처리 및 보유 기간)</h3>
        <p>보유 기간이 기재되어 있지 않은 경우 제공 목적이 달성되는 시점/회원 탈퇴/관련 법령에 따른 보존 기간까지 제공된 정보가 이용됩니다.</p>
        <p>개인 정보는 사용자가 동의한 서비스의 수집〮이용 기간에만 위 처리 목적을 위하여 보유〮이용되며, 회원 탈퇴 시 지체없이 파기됩니다. 다만, 아래의 경우를 포함하여 관계 법령에 따라 개인 정보를
          보존해야하는 경우에는 해당 정보를 보관합니다.</p>
        <ol>
          <li>계약 또는 청약철회 등에 관한 기록 보유: 5년 (전자상거래 등에서의 소비자 보호에 관한 법률 시행령)</li>
          <li>대금결제 및 재화 등의 공급에 관한 기록 보유: 5년 (전자상거래 등에서의 소비자 보호에 관한 법률 시행령)</li>
          <li>소비자 불만 또는 분쟁 처리에 관한 기록 보유: 3년 (전자상거래 등에서의 소비자 보호에 관한 법률 시행령)</li>
          <li>고객확인 의무 정보 : 5년 (특정 금융거래 정보의 보고 및 이용 등에 관한 법률)</li>
          <li>방문에 관한 기록 보유: 3개월 (통신비밀 보호법)</li>
          <li>광고/마케팅 수신: 동의 철회 또는 회원 탈퇴 시까지</li>
        </ol>
        <p>반복적인 회원 탈퇴 및 재가입으로 인한 경제적 이익 취득 등 불법, 편법 행위 차단을 위해 문제되는 이용자의 개인정보(회사 ID, 탈퇴 일자 등)를 회원 탈퇴 후 1년간 보유할 수
          있습니다.</p>
        <p>&nbsp;</p>

        <h3>제4조 (만 14세 미만 아동의 가입 제한)</h3>
        <p>회사는 법정 대리인의 동의가 필요한 만 14세 미만 아동의 서비스 이용 및 회원가입을 제한하고 있습니다.</p>
        <p>&nbsp;</p>

        <h3>제5조 (개인정보의 파기절차 및 방법)</h3>
        <p>회사는 개인 정보의 수집 및 이용 목적이 달성하거나 개인정보 보유 기간이 경과된 경우에는 해당 정보를 즉시 파기하는 것을 원칙으로 합니다.</p>
        <ol>
          <li>파기 절차 : 사용자가 서비스를 이용하기 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 저장되어 내부 방침 및 기타 관련 법령에 따라 관리되며 보유 기간이 만료된 후에 삭제되거나
            파기됩니다.
          </li>
          <li>파기 기한 : 사용자의 개인 정보는 개인정보의 보유기간이 만료된 경우 보유기간 종료일로부터 5일 이내에 파기합니다.</li>
          <li>파기 방법 : 종이에 출력된 개인 정보는 분쇄기로 분쇄 또는 소각하여 파기합니다. 전자적 파일 형태로 저장된 개인정보는 복구가 불가능한 기술적 방법으로 영구 삭제합니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제6조 (개인정보 제 3자의 제공)</h3>
        <p>회사는 제 1조 “개인 정보의 수집 및 이용 목적”에 고지한 범위 내에서 이용자의 개인 정보를 수집 및 이용하며, 사용자의 동의 없이는 목적 범위를 초과하여 사용하거나 제 3자에게 제공하지
          않습니다.</p>
        <p>다만, 다음의 경우에는 예외로 합니다.</p>
        <ol>
          <li>회사의 서비스 수행에 직접적으로 관계되어 있는 업체에 한해서 제한적으로 다음과 같이 개인 정보가 제공됩니다.</li>
          <table>
            <tbody>
            <tr>
              <th>제공받는 자</th>
              <th>제공 목적</th>
              <th>제공 정보</th>
              <th>이용 및 보유기간</th>
            </tr>
            <tr>
              <td>건강검진 신청 병의〮원과 심리상담 신청 심리상담소</td>
              <td>서비스 이용(건강검진, 심리상담 예약 서비스)과 고객 상담, 불만처리 및 요금 정산</td>
              <td>이름, 성별, 생년월일, 휴대전화번호, 주소, 예약정보(건강검진/심리상담 예약일, 검진패키지명, 금액 등), 소속회사(기업 회원일 경우)</td>
              <td>회원 탈퇴 후 2년</td>
            </tr>
            <tr>
              <td>기업 건강검진 또는 심리상담 담당자(보건관리자)</td>
              <td>기업의료복지로 진행되는 건강검진 및 심리상담의 경우 기업담당자는 관리의 의무 및 정산 등의 목적으로 정보가 제공됨</td>
              <td>이름, 성별, 생년월일, 휴대전화번호, 주소, 예약정보(건강검진/심리상담 예약일, 검진패키지명, 금액 등), 소속회사</td>
              <td>회원 탈퇴 후 2년</td>
            </tr>
            </tbody>
          </table>
          &nbsp;
          <li>법령에 정해진 의무 또는 수사목적으로 법령에서 정해진 절차와 방법에 따라 수사 기관의 정당한 요청이 있는 경우 해당 기관에 제공됩니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제7조 (개인정보의 열람 및 정정)</h3>
        <p>사용자는 개인 정보의 수집이〮용제〮공에 대한 동의는 언제든지 거부할 수 있습니다. 모바일 앱, 웹사이트, 이메일 및 전화들 통해 연락하시면 지체없이 필요한 조치하겠습니다.</p>
        <table>
          <tbody>
          <tr>
            <th>웹사이트</th>
            <th>이메일</th>
            <th>전화</th>
          </tr>
          <tr>
            <td>dual.health</td>
            <td>help@dual.health</td>
            <td>1661-2645</td>
          </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>

        <h3>제8조 (사용자 및 법정 대리인의 권리)</h3>
        <p>사용자는 회사에게 언제든지 개인 정보 열람정〮정삭〮제처〮리정지 요구 등의 권리를 행사할 수 있습니다. 사용자는 회사의 개인정보 처리에 동의하지 않은 경우 동의철회(회원탈퇴)를 요청할 수
          있습니다.</p>
        <p> 단, 이 경우 서비스의 전부 또는 일부 이용이 어려울 수 있습니다.</p>
        <p>&nbsp;</p>
        <p>개인 정보의 열람정〮정삭〮제처〮리정지 등의 절차는 아래와 같습니다.</p>
        <ol>
          <li>요청 접수</li>
          <li>본인 또는 법정 대리인 확인</li>
          <li>요구사항 조치</li>
          <li>처리 결과 안내</li>
        </ol>
        <p>권리 행사는 사용자의 법정 대리인이나 위임을 받은 자 등 대리인을 통해 하실 수 있습니다. 이 경우 “개인 정보 처리 방법에 관한 고시” 별지 제 11호 서식에 따른 위임장을 제출하셔야
          합니다. </p>

        <h3>제9조 (사용자의 의무)</h3>
        <p>사용자는 본인의 개인 정보를 주기적으로 관리하여 불의의 사고를 예방해야 합니다. 또한 이용자가 입력한 부정확하고 불법적인 정보로 인해 발생하는 사고의 책임은 사용자에게 있습니다. 또한 허락되지
          않는 광고 및 허위 게시글로 인해 타인으로부터 신고가 들어오는 경우 해당 게시물은 삭제될 수 있으며 회원 자격이 상실될 수 있습니다.</p>
        <p>&nbsp;</p>

        <h3>제10조 (개인 정보의 기술적관〮리적 보호 대책)</h3>
        <ol>
          <li>기술적 대책
            <ul>
              <li>회사는 백신 프로그램을 주기적으로 사용하여 보안 유지에 최선을 다하며 데이터에 암호 알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안 장치를 채택하고
                있습니다.
              </li>
              <li>회사는 해킹 등 외부 침입에 대비하여 각 서버마다 침입 차단 시스템과 개인정보관리 전문 솔루션을 항시 가동하고 있습니다.</li>
            </ul>
          </li>
          <li>관리적 대책
            <ul>
              <li>회사는 개인 정보에 대한 접근 권한을 최소한의 인원으로 제한하고 해당 인원에게 보안서약서를 작성하여 정보 유출을 사전에 방지하고 개인정보처리방침에 대한 이행 사항 및 직원의 준수
                여부를 감사하기 위해 내부절차를 마련하고 있습니다.
              </li>
              <li>전 직원을 대상으로 개인정보보호 의무에 관한 정기적인 교육을 시행하고 있습니다.</li>
              <li>그러나 회사는 사용자의 개인적인 실수나 기본적인 인터넷의 위험성 때문에 발생하는 일들은 책임지지 않습니다. 사용자는 본인의 개인정보를 보호하기 위해 자신의 아이디와 비밀번호를
                스스로
                책임하에 관리해야 합니다. 다른 사람이 추측할 수 있는 쉬운 비밀번호는 사용을 피하고 정기적으로 비밀번호를 변경하는 것이 바람직합니다.
              </li>
            </ul>
          </li>
        </ol>
        <p>&nbsp;</p>

        <h3>제11조 (권익 침해 구제 방법)</h3>
        <p>사용자는 개인 정보 침해로 인한 구제를 받기 위하여 상담이나 신고가 필요한 경우 아래 연락처에 문의하여 도움을 받을 수 있습니다.</p>
        <ul>
          <li>개인정보 분쟁조정위원회 (https://www.kopico.go.kr/main/main.do/ 1833-6972)</li>
          <li>개인정보 침해신고센터 (http://privacy.kisa.or.kr / 국번 없이 118)</li>
          <li>대검찰청 사이버수사과(http://spo.go.kr / 국번 없이 1301)</li>
          <li>경찰청 사이버안전국(http://cyberbureau.police.go.kr / 국번 없이 182)</li>
        </ul>
        <p>&nbsp;</p>

        <h3>제12조 (개인정보보호 책임자)</h3>
        <p>고객의 개인정보를 보호하고 개인정보와 관련한 문의나 불만 등은 개인정보 보호책임자 혹은 담당부서로 문의할 수 있습니다. 개인정보를 보호하는데 있어 이용자에게 고지한 사항들에 반하는 사고가
          발생할 시에 개인정보 보호책임자가 모든 책임을 집니다.</p>
        <p>그러나 기술적인 보완조치를 했음에도 불구하고 해킹 등 기본적인 네트워크상의 위험성에 의해 발생하는 예기치 못한 사고로 인한 정보의 훼손 및 사용자/방문자가 작성한 게시물에 의한 각종 분쟁에
          관해서는 책임이 없습니다.</p>
        <table>
          <thead>
          <tr>
            <th>개인정보보호 담당자</th>
            <th>개인정보보호 책임자</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>성 명 : 류승윤<br/>
              소 속 : 전산개발팀<br/>
              직 책 : 대리<br/>
              이메일 : privacy@dual.health<br/>
              연락처 : 1661-2645<br/>
            </td>
            <td>성 명 : 김영이<br/>
              소 속 : -<br/>
              직 책 : 대표<br/>
              이메일 : yykim@dual.health<br/>
              연락처 : 1661-2645<br/>
            </td>
          </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>

        <h3>제13조 (변경에 따른 공지)</h3>
        <p>회사는 본 개인정보처리방침을 변경하는 경우 그 변경 사유 및 적용일자를 명시하고 서비스 화면에 고지합니다. 다만 이용자의 권리 또는 의무에 중요한 내용의 변경이 있을 경우 최소 30일 전에
          고지합니다. </p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>공지일자 : 2025년 2월 6일</p>
        <p>&nbsp;</p>
        <p>시행일자 : 2025년 2월 13일</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>2023년 2월 1일(2차 계정)</p>
        <p>&nbsp;</p>
        <p>2021년 2월 1일(최초 제정)</p>
        <p>&nbsp;</p>


      </Box>


      <Bottom/>

    </Box>

  );
}


export default Private;